import { NoContextImage } from '@/components/Image';
import { Col } from "@/components/Theme/Col";
import { ResponsiveRow } from "@/components/Theme/ResponsiveRow";
import toNumber from "lodash/toNumber";

export function imageRowParser(node, children, parent, styles, colorScheme) {
    
    const columns = toNumber(node.attributes.columns ?? 2);
    const gap = toNumber(node.attributes.gap ?? 12);
    const images = JSON.parse(node.attributes.images ?? "[]");
    
    return (
        <ResponsiveRow key={node.key} gap={gap} flexWrap="wrap">
            {images?.map((src, index) => {

                const fullSrc = src?.src;
    
                if (!fullSrc) 
                    return null;
                
                const rawAlt = src?.alt || "";

                const parts = rawAlt.split("|").map(s => s.trim()).filter(Boolean);

                const opts = Object.fromEntries(
                    parts.slice(1).map(p => {
                        const [k, v] = p.split("=").map(x => x?.trim());
                        return [k, v];
                    })
                );

                const height = opts.height ? toNumber(opts.height) : undefined;

                const width = opts.width === "100%" ? "100%" : (opts.width ? toNumber(opts.width) : "100%");
                const fit = opts.fit || "cover";
                
                const updatedSrc = fullSrc
                    ?.replace('resize=1200', `resize=400`)
                    ;
                
                return (
                    <Col xs={12} md={12 / columns} alignItems={"center"} justifyContent={"center"}>
                
                        <NoContextImage
                            source={{ uri: updatedSrc }}
                            style={{ width: '100%', aspectRatio: width/height}}
                            contentFit={fit}
                            contentPosition="center"
                            priority="high"
                            accessibilityLabel={parts[0] ?? "Image"}
                            accessibilityRole="image"
                        />
            
                    </Col>
                );

            })}
        </ResponsiveRow>
    )


}